import { UserProfilePermissionLevel } from '@/enums/UserProfilePermissionLevel'
import { useAuthStore } from '@/stores/auth'

export function checkPermissions(targetPermissionLevel: UserProfilePermissionLevel) {
  const authStore = useAuthStore()

  switch (targetPermissionLevel) {
  case UserProfilePermissionLevel.STUDENT_VIEWER:
    return authStore.userProfilePermissionLevel === UserProfilePermissionLevel.STUDENT_VIEWER
        || authStore.userProfilePermissionLevel === UserProfilePermissionLevel.STUDENT_MANAGER
        || authStore.userProfilePermissionLevel === UserProfilePermissionLevel.ADMIN
  case UserProfilePermissionLevel.STUDENT_MANAGER:
    return authStore.userProfilePermissionLevel === UserProfilePermissionLevel.STUDENT_MANAGER
        || authStore.userProfilePermissionLevel === UserProfilePermissionLevel.ADMIN
  case UserProfilePermissionLevel.ADMIN:
    return authStore.userProfilePermissionLevel === UserProfilePermissionLevel.ADMIN
  }
}
